import { render, staticRenderFns } from "./AddWorkOrders.vue?vue&type=template&id=2dd8be95&scoped=true"
import script from "./AddWorkOrders.vue?vue&type=script&lang=js"
export * from "./AddWorkOrders.vue?vue&type=script&lang=js"
import style0 from "./AddWorkOrders.vue?vue&type=style&index=0&id=2dd8be95&prod&scoped=true&lang=scss"
import style1 from "./AddWorkOrders.vue?vue&type=style&index=1&id=2dd8be95&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd8be95",
  null
  
)

export default component.exports